import {Type} from '@angular/core';

import {BaseFilter} from './base/base.filter';

export class UrbisFilter extends BaseFilter {

    public idUserUrbis: string;

    public constructor() {
        super();
    }

    protected getType(): Type<BaseFilter> {
        return UrbisFilter;
    }
}
